export enum InternBondEnum {
  DEFENSORIA = 1,
  ADMINISTRATIVO = 2,
  RECEPCAO = 3,
}

export function internBondEnumInFull(status: InternBondEnum): string {
  switch (status) {
    case InternBondEnum.DEFENSORIA:
      return 'Defensoria';
    case InternBondEnum.ADMINISTRATIVO:
      return 'Setor Administrativo';
    case InternBondEnum.RECEPCAO:
      return 'Recepção';
    default:
      return '-';
  }
}

export function getinternBondEnumOptions(): {
  value: InternBondEnum;
  label: string;
}[] {
  return Object.values(InternBondEnum)
    .filter((v) => typeof v === 'number')
    .map((value) => ({
      value: value as InternBondEnum,
      label: internBondEnumInFull(value as InternBondEnum),
    }));
}
